import React from 'react';
import { CheckIcon } from 'lucide-react';
export function OfferSection({
  config,
  selectedPack,
  onPackSelect
}) {
  const offers = [{
    id: 'single',
    title: '1 Pack',
    subtitle: 'Try it',
    price: config.pricing.singlePack,
    originalPrice: config.pricing.singlePackOriginal,
    savings: Math.round((config.pricing.singlePackOriginal - config.pricing.singlePack) / config.pricing.singlePackOriginal * 100),
    description: '12 patches',
    subtext: 'Covers one knee for ~12 days',
    freeShipping: true,
    bonus: null
  }, {
    id: 'twoGetOne',
    title: 'Buy 2 Get 1 FREE',
    subtitle: 'Most Popular',
    price: config.pricing.twoGetOne,
    originalPrice: config.pricing.singlePack * 3,
    savings: Math.round((config.pricing.singlePack * 3 - config.pricing.twoGetOne) / (config.pricing.singlePack * 3) * 100),
    description: '36 patches (3 packs)',
    subtext: 'Covers both knees ~3 weeks',
    freeShipping: true,
    bonus: null,
    highlight: true,
    highlightText: 'Most Popular'
  }, {
    id: 'threeGetTwo',
    title: 'Buy 3 Get 2 FREE',
    subtitle: 'Best Value',
    price: config.pricing.threeGetTwo,
    originalPrice: config.pricing.singlePack * 5,
    savings: Math.round((config.pricing.singlePack * 5 - config.pricing.threeGetTwo) / (config.pricing.singlePack * 5) * 100),
    description: '60 patches (5 packs)',
    subtext: 'Covers both knees ~5 weeks',
    freeShipping: true,
    bonus: null,
    bestValue: true
  }];
  // Function to handle checkout with Shopify
  const handleAddToCart = () => {
    try {
      // Get quantity based on selected pack
      let quantity = 1;
      if (selectedPack === 'twoGetOne') {
        quantity = 3;
      } else if (selectedPack === 'threeGetTwo') {
        quantity = 5;
      }
      // Get reminder preference safely
      const reminderElement = document.getElementById('reminder');
      const reminderChecked = reminderElement && reminderElement.checked ? true : false;
      // Use the actual Shopify variant ID provided by the user
      const variantId = config.shopify?.variantId || '52168809939271';
      // Create the Shopify cart URL using myoquell.com domain
      // Using the correct format for Shopify cart URLs
      const shopifyCartUrl = `https://myoquell.com/cart/${variantId}:${quantity}`;
      // Note: The reminder preference would need to be handled differently with this URL format
      // We could potentially use a cookie or local storage to remember this preference
      // Open the cart URL in a new tab to avoid navigation issues
      window.open(shopifyCartUrl, '_blank');
    } catch (error) {
      console.error('Error during checkout:', error);
      alert('There was an error adding the product to cart. Please try again.');
    }
  };
  return <section className="py-12 bg-white" data-id="element-237">
      <div className="container mx-auto px-4" data-id="element-238">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-[#0E6B6B]" data-id="element-239">
          Choose Your MyoQuell™ Package
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-240">
          {offers.map(offer => <div key={offer.id} className={`border-2 rounded-xl p-6 relative ${selectedPack === offer.id ? 'border-[#0E6B6B] shadow-md' : 'border-gray-200 hover:border-[#35A67E]'} ${offer.highlight ? 'md:-mt-4 md:mb-4' : ''}`} data-id="element-241">
              {offer.highlight && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#E6B17E] text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-242">
                  Most Popular
                </div>}
              {offer.bestValue && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#0E6B6B] text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-243">
                  Best Value
                </div>}
              <div className="text-center mb-6" data-id="element-244">
                <h3 className="text-xl font-bold" data-id="element-245">{offer.title}</h3>
                <p className="text-gray-600" data-id="element-246">{offer.subtitle}</p>
              </div>
              <div className="text-center mb-6" data-id="element-247">
                <div className="text-3xl font-bold" data-id="element-248">
                  ${offer.price.toFixed(2)}
                </div>
                {offer.savings && <div className="text-[#35A67E] text-sm" data-id="element-249">
                    <span className="line-through text-gray-400 mr-1" data-id="element-250">
                      ${offer.originalPrice.toFixed(2)}
                    </span>
                    Save {offer.savings}%
                  </div>}
              </div>
              <div className="mb-6" data-id="element-251">
                <div className="font-medium mb-1" data-id="element-252">{offer.description}</div>
                <div className="text-sm text-gray-600 mb-4" data-id="element-253">
                  {offer.subtext}
                </div>
                {offer.freeShipping && <div className="flex items-center text-sm text-[#35A67E] mb-2" data-id="element-254">
                    <CheckIcon size={16} className="mr-1" data-id="element-255" />
                    <span data-id="element-256">Free shipping</span>
                  </div>}
                {offer.bonus && <div className="flex items-center text-sm text-[#35A67E]" data-id="element-257">
                    <CheckIcon size={16} className="mr-1" data-id="element-258" />
                    <span data-id="element-259">{offer.bonus}</span>
                  </div>}
              </div>
              <button onClick={() => onPackSelect(offer.id)} className={`w-full py-3 px-4 rounded-full text-center font-medium transition-colors ${selectedPack === offer.id ? 'bg-[#0E6B6B] text-white' : 'bg-white text-[#0E6B6B] border border-[#0E6B6B] hover:bg-[#EAF7F3]'}`} data-id="element-260">
                {selectedPack === offer.id ? 'Selected' : 'Select Package'}
              </button>
            </div>)}
        </div>
        <div className="max-w-lg mx-auto mt-8" data-id="element-261">
          <div className="bg-[#EAF7F3] p-4 rounded-lg flex items-center" data-id="element-262">
            <input type="checkbox" id="reminder" className="h-5 w-5 rounded border-gray-300 text-[#0E6B6B] focus:ring-[#0E6B6B]" data-id="element-263" />
            <label htmlFor="reminder" className="ml-2 text-gray-700" data-id="element-264">
              Remind me to re-order in ~3 weeks
            </label>
          </div>
          <div className="mt-6" data-id="element-265">
            <button onClick={handleAddToCart} className="w-full py-4 px-6 bg-[#0E6B6B] text-white text-lg font-medium rounded-full hover:bg-[#095959] focus:outline-none focus:ring-2 focus:ring-[#0E6B6B] focus:ring-offset-2 transition-colors" data-id="element-266">
              BUY NOW
            </button>
          </div>
        </div>
      </div>
    </section>;
}